module.exports = __webpack_public_path__ + "img/prize0.19f4d4a.png";